module.exports = "<img [src]=\"src\" *ngIf=\"src\" class=\"picture\" />\n<i class=\"fa\" [ngClass]=\"icon\" *ngIf=\"!src\"> </i>\n"